import router from './router';

const axios = require('axios');

axios.interceptors.response.use((response: any) => response, (error: any) => {
  if (error.response.status === 401) {
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `/api/auth/login?callback=${redirect}`;
  }
  /*
  if (error.response.status === 403) {
    router.push('/error');
  }
  */
  return Promise.reject(error);
});
